import { render, staticRenderFns } from "./barCharts.vue?vue&type=template&id=1a6a198f"
import script from "./barCharts.vue?vue&type=script&lang=js"
export * from "./barCharts.vue?vue&type=script&lang=js"
import style0 from "./barCharts.vue?vue&type=style&index=0&id=1a6a198f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports